import angular from 'angular';

import HealthcarebookLanguageComponent from './language.component';

export default angular.module('healthcarebookLanguage', [])
    .component('healthcarebookLanguageComponent', HealthcarebookLanguageComponent)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/language/language.module.js
// module id = 344
// module chunks = 0